var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{class:{ 'nav-open': _vm.NavbarStore.showNavbar }},[_c('router-view',{attrs:{"name":"header"}}),_c('div',[_c('router-view')],1),_c('router-view',{attrs:{"name":"footer"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }